import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { StarsButton as Button } from '@ps/web-shared-components';
import React from 'react';
import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import RegulatoryCheckboxes from '@swf/components/RegulatoryCheckboxes/RegulatoryCheckboxes';
import { select } from '@swf/core/store';
import type { RootState } from '@swf/core/store';

import AccountSecurityInfo from '../AccountSecurityInfo/AccountSecurityInfo';

import { TXTCLI_Continue, TXTCLI_Create_Account } from './RegistrationEulaFields.messages.json';

export interface RegistrationEulaFormValues {
  marketingMailList: boolean;
  selectAll: boolean;
  eula?: boolean;
  privacy?: boolean;
  combinedEulaPrivacy?: boolean;
  gamingAccAgreement?: boolean;
}

const RegistrationEulaFields = () => {
  const siteId = useSelector(select.cms.getSiteId);
  const loading = useSelector((rootState: RootState) => !!rootState.loading?.models.auth);
  const verificationRequired = useSelector(select.account.isAgeVerificationRequired);
  const disableNewUkAge = useFeature(FeatureFlag.DisableNewUkAgeVerificationFlow);
  const variant = 'stars';
  const { invalid, validating, pristine, submitting } = useFormState<RegistrationEulaFormValues>();

  return (
    <>
      <RegulatoryCheckboxes variant={variant} isSelectAllToggleVisible={variant === 'stars'} />
      {[Sites.US_PA, Sites.USMI].includes(siteId) && <AccountSecurityInfo />}
      <ButtonGroup>
        <Button
          block
          type="submit"
          disabled={invalid || submitting || pristine}
          loading={loading || validating}
          translation={
            !disableNewUkAge && verificationRequired ? TXTCLI_Continue : TXTCLI_Create_Account
          }
        />
      </ButtonGroup>
    </>
  );
};

export default RegistrationEulaFields;
